
import {React, FC, useContext, Select, useMemo} from 'external/react'
import {styled} from 'external/material'

import { TeacherContext } from 'teacher/context'
import confirmDialog from 'components/confirm-dialog'


const StyledSelectTemplate = styled('div')(selectTemplateStyles as any)

const SelectTemplate: FC = props => {


    const {planTemplates, translate, navigate, query, match} = useContext(TeacherContext) as any

    const templates = useMemo(() => 
      planTemplates.map((template:any) => (
        template.label == 'default'
          ? {...template, label: translate('default_template_label').replace('rd-', '')}
        : template
      ))
    , [planTemplates])


    const template = useMemo(() => templates.find((template:any) => template.value === query.template), [templates, query.template])

    function applyTemplate (option:any) {
      const {value: template, label} = option
      if (query.template !== template) {
        confirmDialog({
          className: 'apply-template',
          translate: translate,
          children: (
            <div className="message">
              <div className="question">
                {translate('confirm_apply_template')}
              </div>
              <div className="title">
                {label}
              </div>
            </div>
          ),
          onConfirm: () => {
            const query = {template}
            navigate({}, match.path, {preserveQuery: true, query})
          }
        })
      }
    }

    return (
     <StyledSelectTemplate className="apply-template">
        <Select
          className="templates"
          classNamePrefix="select-"
          isSearchable={false}
          value={template}
          onChange={applyTemplate}
          options={templates}
        />
      </StyledSelectTemplate>
    )
}

function selectTemplateStyles() {

  return {
    cursor: "pointer",
    minWidth: "250px",
    ".apply-template.confirm-dialog": {
      border: "solid 1px #bcc0c9",
      color: "#515a71",
      borderRadius: "6px",
      padding: "20px",
      backgroundColor: "#edf1f5",
      "& .question": {
        fontSize: "15pt"
      },
      "& .title": {
        fontSize: "12pt",
        marginTop: "10px",
        marginLeft: "12px"
      },

      "& .buttons": {
        display: "flex",
        justifyContent: "flex-end",
        paddingTop: "20px",

        "& .button": {
          cursor: "pointer",
          width: "50px",
          textAlign: "center",
          borderRadius: "5px",
          padding: "4px 0",

          "&:hover": {
            transform: "scale(1.04)"
          },

          "&.yes": {
            marginRight: "15px",
            border: "solid 1px #2ca5ec",
            backgroundColor:"#2ca5ec",
            color: "#fff"
          },

          "&.no": {
            border: "solid 1px #c2c5c6",
            color: "#ef4747"
          }
        }
      }
    }
  }
}

export {SelectTemplate as default}